import { ISortRequestParams } from './shared.dto';

abstract class IAttributesDAO {
    public abstract getEventAttributesList(params:
        { accountId: number; inputTypes?: EventAttributeTypesValues[] }
        & ISortRequestParams<TGetEventAttributesSortKeys>
    ): Promise<IEventAttributeDAO>;
    public abstract createEventAttribute(params: IEventAttributeRequestDAO): Promise<IEventAttributeDetailsDTO>;
    public abstract getEventAttributeDetails(params: { accountId: number; eventAttributeId: number }): Promise<IEventAttributeDetailsDTO>;
    public abstract updateEventAttribute(params: IEventAttributeRequestDAO & { eventAttributeId: number }): Promise<IEventAttributeDetailsDTO>;
    public abstract deleteEventAttribute(params: { accountId: number; eventAttributeId: number }): Promise<void>;
}

enum EventAttributesActiveStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
}

type TGetEventAttributesSortKeys = 'createdAt' | 'eventAttributeName';

const EventAttributesActiveStatusLabel = {
    [EventAttributesActiveStatus.ACTIVE]: 'Active',
    [EventAttributesActiveStatus.INACTIVE]: 'Inactive',
};

interface IEventAttributeDetailsDTO {
    eventAttributeId: number;
    eventAttributeName: string;
    active: boolean;
    description: string;
    inputType: string;
    level: number;
    externalId: string;
    createdAt: string;
    values?: AttributeValue[];
    usedInEvents?: boolean;
    usedInEventsCount?: number;
}

interface IEventAttributeRequestDAO {
    eventAttributeName: string;
    active: boolean;
    inputType: string;
    description: string;
    externalId: string;
    accountId: number;
    values?: AttributeValue[];
}

interface AttributeValue {
    attributeOrder: number;
    label: string;
    active: boolean;
    externalId?: string;
    valueId?: number;
};

interface IEventAttributeDAO {
    content: IEventAttributeDetailsDTO[];
    totalElements: number;
}

export enum EventAttributeTypesValues {
    SINGLE_SELECT_DROPDOWN = 'SINGLE_SELECT_DROPDOWN',
    CHECKBOX = 'CHECKBOX',
    MULTI_SELECT_DROPDOWN = 'MULTI_SELECT_DROPDOWN',
    FREE_TEXT = 'FREE_TEXT',
    PARAGRAPH = 'PARAGRAPH',
}

export enum EventAttributeTypesLabels {
    SINGLE_SELECT_DROPDOWN = 'Single-select Dropdown',
    CHECKBOX = 'Checkbox',
    MULTI_SELECT_DROPDOWN = 'Multi-select Dropdown',
    FREE_TEXT = 'Free Text',
    PARAGRAPH = 'Paragraph',
}

export interface IEventAttributesTypes {
    value: EventAttributeTypesValues;
    label: string;
}

export {
    EventAttributesActiveStatus,
    EventAttributesActiveStatusLabel,
    TGetEventAttributesSortKeys,
    IEventAttributeDAO,
    IEventAttributeDetailsDTO,
    IAttributesDAO,
    IEventAttributeRequestDAO,
    AttributeValue,
};